import Typography from "@mui/material/Typography";

export default function TermsOfUse() {
  return (
    <div style={{ padding: "1rem" }}>
      <Typography variant="h4" sx={{ margin: 0, textAlign: "center" }}>תנאי שימוש באתר מיציטופיה</Typography>
      <Typography variant="h6" sx={{ margin: 0, textAlign: "justify", padding: "0 0.5rem" }}>
        תקנון השימוש באתר הנ"ל נכתב בלשון זכר אך האמור בו מתייחס לנשים וגברים
        כאחד.
      </Typography>
      <ol style={{ paddingLeft: "1rem" }}>
        <li>
          <Typography sx={{ fontWeight: 700 }}>קדימון</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            אתר מיציטופיה (להלן "האתר") הוא אתר המשמש כאתר לצרכי משחק ו/או
            שעשוע בלבד ואין כל קשר בין האמור בו לבין המציאות הפוליטית ו/או
            המדינית הקיימת בכל מדינה שהיא.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            אנו מזמינים את משתמשינו לעשות שימוש באתר זה בכפוף להסכמתם לתנאי
            השימוש אשר יפורטו להלן
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            בנוסף השימוש באתר זה על כל תכניו והשירותים המוצעים בו עשויים
            להשתנות מעת לעת או בהתאם לסוג התוכן.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            הנהלת האתר שומרת לעצמה הזכות לעדכן את תנאי השימוש המוצגים להלן מעת
            לעת וללא התראה או אזכור מיוחד.
          </Typography>
        </li>
        <li>
          <Typography sx={{ fontWeight: 700 }}>קניין רוחני</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            האתר כמו גם כל המידע שבו לרבות עיצוב האתר, קוד האתר, קבצי מדיה
            לרבות גרפיקות, סרטונים, תמונות, טקסטים, קבצים המוצעים להורדה וכל
            חומר אחר אשר מוצג באתר שייכים במלואם לאתר הנ"ל ומהווים קניין רוחני
            בלעדי של אתר מיציטופיה ואין לעשות בהם שימוש ללא אישור כתוב מראש
            ממנהלי האתר.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            בנוסף אין להפיץ, להעתיק, לשכפל, לפרסם, לחקות או לעבד פיסות קוד,
            גרפיקות, סרטונים, סימנים מסחריים או כל מדיה ותוכן אחר מבלי שיש
            ברשותכם אישור כתוב מראש.
          </Typography>
        </li>
        <li>
          <Typography sx={{ fontWeight: 700 }}>תוכן האתר</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            אנו שואפים לספק לכם את המידע המוצג באתר ללא הפרעות אך יתכנו בשל
            שיקולים טכניים, תקלות צד ג או אחרים, הפרעות בזמינות האתר. ולכן
            איננו יכולים להתחייב כי האתר יהיה זמין לכם בכל עת ולא יינתן כל
            פיצוי כספי או אחר בשל הפסקת השירות / הורדת האתר.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            קישורים לאתרים חיצוניים אינם מהווים ערובה כי מדובר באתרים בטוחים,
            איכותיים או אמינים וביקור בהם נעשה על דעתכם האישית בלבד ונמצאים
            בתחום האחריות הבלעדי של המשתמש באתר.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            התכנים המוצעים באתר הינם בבעלותם הבלעדית של הנהלת האתר ואין לעשות
            בהם שימוש אשר נוגד את האמור בתקנון זה (ראה סעיף 3) למעט במקרים בהם
            צוין אחרת או במקרים בהם צוין כי זכויות היוצרים שייכים לגוף חיצוני.
            במקרים אלו יש לבדוק מהם תנאי השימוש בקישור המצורף ולפעול על פי
            המצוין באתר החיצוני לו שייכים התכנים.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            המשחק באתר מכיל חוקים שונים, שניתנים לפרשנויות שונות. הפרשנות
            המוצעת במשחק הינה על דעתם של בעלי האתר בלבד ואין בכך כדי לשלול
            דעות אחרות ו/או לפגוע בבעלי דעות שונות.
          </Typography>
        </li>
        <li>
          <Typography sx={{ fontWeight: 700 }}>ניהול משתמשים ומבקרים באתר</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            הנהלת האתר שומרת לעצמה את הזכות לחסום כל משתמש ובין אם על ידי
            חסימת כתובת הIP של המחשב שלו, כתובת הMACID של המחשב שלו או אפילו
            בהתאם למדינת המוצא ללא צורך לספק תירוץ אשר מקובל על הגולש.
          </Typography>
        </li>
        <li>
          <Typography sx={{ fontWeight: 700 }}>גילוי נאות</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            באתר זה עשוי לעשות שימוש בקבצי קוקיז ובממשקי סטטיסטיקה פנימיים
            בכדי לשמור תיעוד סטטיסטי אנונימי של גולשים וניתוח תנועת הגולש/ים,
            הרגלי גלישה באתר וניתוח קליקים וזמן שהייה.
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            המידע הנשמר הוא אנונימי לחלוטין ואין בו את שם הגולש או כל פרט מזהה
            אחר.
          </Typography>
        </li>
        <li>
          <Typography sx={{ fontWeight: 700 }}>איזור שיפוט</Typography>
          <Typography variant="body1" sx={{ textAlign: "justify" }}>
            בעת שאתם עושים שימוש באתר ובמקרה בו התגלעה כל מחולקת אתם מסכימים
            להלן כי האמור לעיל נמצא תחת סמכות השיפוט הבלעדי של החוק הישראלי
            תוך שימוש במערכת בתי המשפט הישראליים בלבד במחוז תל אביב.
          </Typography>
        </li>
      </ol>
    </div>
  );
}
